import { atom } from "jotai";

/**
 * Whether the GraphQL server is in maintenance (it answers HTTP 503).
 * Written by the Apollo maintenance link (configs/maintenance-link.ts), read by MaintenanceManager.
 */
export const serverInMaintenanceAtom = atom(false);
